<div class="modal" role="dialog" [ngStyle]="{'display': showModal ? 'block': 'none'}" id="search-modal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Adding users to task</h5>
        <button type="button" class="btn btn-close btn-outline-secondary" (click)="closeModal()">
        </button>
      </div>
      <div class="modal-body">
        Search user:
        <input type="text" class="form-control m-1" [(ngModel)]="userQuery" placeholder="type name or email" (keyup.enter)="searchUsers(userQuery)">
        @if (users.length == 0) {
          <div class="m-2">
            {{message}}
          </div>
        }
        <ul class="list-group m-1">
          @for (u of users; track u; let i = $index) {
            <li class="list-group-item">
              <input class="form-check-input" type="checkbox" [(ngModel)]="u.checked" id="flexCheckDefault">
              <span (click)="checkName(i)">
                {{u.name}}
                {{u.email}}
              </span>
            </li>
          }
        </ul>
      </div>
      <div class="m-2">
        <ul class="list-group m-1">
          <li class="list-group-item" >
            <input class="form-check-input" type="checkbox" [(ngModel)]="yourNameChecked" id="flexCheckDefault">
            <span (click)="checkYouName()">
              {{userName}}
              {{userEmail}} (you)
            </span>
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <div class="btn-group" role="group" >
          <button type="button" class="btn btn-outline-secondary">
            <i class="bi bi-search" (click)="searchUsers(userQuery)"></i>
          </button>
          @if (users.length > 0 || yourNameChecked == true) {
            <button type="button" class="btn btn-outline-secondary" (click)="addUserToWorkpackage()">
              <i class="bi bi-person-plus"></i>
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>